import { Field } from 'react-final-form'
import { string, func } from 'prop-types'

const withRFF = Component => props => {
  const {
    validate,
    parse,
    label,
    info,
    type,
    value,
    errorClassName,
    labelClassName,
    subLabel,
    subLabelClassName,
    wrapperClassName,
    initialValue,
    withAsterisk,
    ...inputProps
  } = props;

  // Helper to append asterisk to label if withAsterisk is true
  const getLabel = () => {
    if (withAsterisk && typeof label === 'string') {
      return <span>{label}<span style={{ color: 'red' }}> *</span></span>;
    }
    return label;
  };

  return (
    <Field name={props.name} validate={validate} parse={parse} type={type} value={value} initialValue={initialValue}>
      {({ input, meta }) => {
        const isInvalid = (meta.error || meta.submitError) && meta.touched;
        const error = meta.error || meta.submitError;

        return (
          <Component
            errorProps={{ isInvalid, error, isDisabled: props.disabled, errorClassName }}
            labelProps={{ label: getLabel(), isDisabled: props.disabled, labelClassName, info }}
            subLabelProps={{ subLabel, subLabelClassName }}
            componentProps={{ ...input, ...inputProps, isInvalid, wrapperClassName }}
          />
        );
      }}
    </Field>
  );
}

export const RFFFieldPropTypes = {
  input: {
    value: string,
    onChange: func,
  },
  meta: {
    error: string,
    submitError: string,
  },
}

export default withRFF
